import React from "react";

import { Box, Typography } from "@mui/material";

import useLocalization from "../../hooks/useLocalization";

import Input from "../elements/Input";

const AddressEditor = ({ title, value, onChange }) => {
  const { getLabel } = useLocalization();

  const getFieldValue = (fieldName) => {
    if (typeof value !== "object") {
      return "";
    }

    if (!value) return "";

    return value[fieldName] || "";
  };

  const handleChange = (fieldName, newValue) => {
    if (typeof value !== "object") {
      onChange({ [fieldName]: newValue });
    } else {
      onChange({ ...value, [fieldName]: newValue });
    }
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={1}
    >
      <Typography>{title}</Typography>
      <Input
        id="streetAddress"
        label={getLabel("address_street")}
        value={getFieldValue("streetAddress")}
        onChange={(newValue) => handleChange("streetAddress", newValue)}
        fullwidth
      />
      <Input
        id="otherAddress"
        label={getLabel("address_other")}
        value={getFieldValue("otherAddress")}
        onChange={(newValue) => handleChange("otherAddress", newValue)}
        fullwidth
      />
      <Box
        display="flex"
        gap={1}
      >
        <Input
          id="city"
          label={getLabel("address_city")}
          value={getFieldValue("city")}
          onChange={(newValue) => handleChange("city", newValue)}
        />
        <Input
          id="province"
          label={getLabel("address_province")}
          value={getFieldValue("province")}
          onChange={(newValue) => handleChange("province", newValue)}
        />
        <Input
          id="postal"
          label={getLabel("address_postal")}
          value={getFieldValue("postal")}
          onChange={(newValue) => handleChange("postal", newValue)}
        />
      </Box>
    </Box>
  );
};

export default AddressEditor;
